import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';

const Process = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section id="process" className="py-20 md:py-32 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Header */}
        <div className="text-center mb-20 relative overflow-hidden">
          <motion.div
            ref={ref}
            className="inline-flex items-center space-x-3 bg-white/10 backdrop-blur-sm rounded-full px-6 py-3 mb-8"
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.2 }}
          >
            <span className="text-xl">⚙️</span>
            <span className="font-semibold tracking-wide">OUR DETAILED METHODOLOGY</span>
          </motion.div>

          <motion.h2
            className="display-text mb-6"
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Our Streamlined Process
            <span className="text-gradient-victory block mt-2">From Strategy to Success</span>
          </motion.h2>

          <motion.p
            className="text-xl text-white/80 max-w-4xl mx-auto leading-relaxed mb-12"
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            We believe in a collaborative and transparent process. Our approach is designed to be straightforward and effective, ensuring that we are aligned with your goals every step of the way. From initial consultation to final implementation, we focus on delivering results.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <Link to="/strategy">
              <button className="bg-jetBlue-600 hover:bg-jetBlue-700 text-white font-bold py-4 px-8 rounded-full transition-all duration-300 transform hover:scale-105">
                Explore Our Strategy
              </button>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Process;
